import { SERVICE_INPUT_ID } from './service-input-id.enum';

export class ServiceInputs {
    /** This file contains an array of ids that represents the inputs for each service */
    public static SERVICE_1 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.SIM_NUMBER,SERVICE_INPUT_ID.CUSTOMER_NAME,SERVICE_INPUT_ID.IDENTIFICATION_NUMBER];

    public static SERVICE_1_3_4 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.SIM_NUMBER];

    public static SERVICE_2 = [SERVICE_INPUT_ID.IDENTIFICATION_NUMBER];

    public static SERVICE_5 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.SIM_NUMBER, SERVICE_INPUT_ID.RECHARGE_NUMBER];

    public static SERVICE_6_9 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.SIM_NUMBER, SERVICE_INPUT_ID.DEVICE_NUMBER];

    public static SERVICE_7_8_11 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.START_DATE, SERVICE_INPUT_ID.END_DATE];

    public static SERVICE_10 = [
        SERVICE_INPUT_ID.CONTACT_NUMBER,
        SERVICE_INPUT_ID.SIM_NUMBER,
        SERVICE_INPUT_ID.START_DATE,
        SERVICE_INPUT_ID.END_DATE,
        SERVICE_INPUT_ID.START_TIME,
        SERVICE_INPUT_ID.END_TIME
    ];

    public static SERVICE_12_19 = [SERVICE_INPUT_ID.CONTACT_NUMBER];

    public static SERVICE_13 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.IDENTIFICATION_NUMBER, SERVICE_INPUT_ID.ACCOUNT_NUMBER];

    public static SERVICE_14 = [
        SERVICE_INPUT_ID.TOWER_NUMBER,
        SERVICE_INPUT_ID.COORDINATES,
        SERVICE_INPUT_ID.START_DATE,
        SERVICE_INPUT_ID.END_DATE,
        SERVICE_INPUT_ID.START_TIME,
        SERVICE_INPUT_ID.END_TIME
    ];

    public static SERVICE_15 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.CAB_NUMBER,SERVICE_INPUT_ID.PLAT_INFO];

    public static SERVICE_16 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.CIRCUIT_NUMBER];

    public static SERVICE_17 = [
        SERVICE_INPUT_ID.CONTACT_NUMBER,
        SERVICE_INPUT_ID.START_DATE,
        SERVICE_INPUT_ID.END_DATE,
        SERVICE_INPUT_ID.START_TIME,
        SERVICE_INPUT_ID.END_TIME
    ];

    public static SERVICE_18 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.MODEM_NUMBER];

    public static SERVICE_20 = [
        SERVICE_INPUT_ID.IP_ADDRESS,
        SERVICE_INPUT_ID.START_DATE,
        SERVICE_INPUT_ID.END_DATE,
        SERVICE_INPUT_ID.START_TIME,
        SERVICE_INPUT_ID.END_TIME
    ];
    public static SERVICE_21 = [
        SERVICE_INPUT_ID.PLAT_INFO,
    ];
    public static SERVICE_110 = [SERVICE_INPUT_ID.CONTACT_NUMBER, SERVICE_INPUT_ID.SLIDE_NUMBER,SERVICE_INPUT_ID.IDENTIFICATION_NUMBER,SERVICE_INPUT_ID.CUSTOMER_NAME,SERVICE_INPUT_ID.PLAT_INFO];

    public static NEW_PRODUCTION_SERVICE = [
        SERVICE_INPUT_ID.CONTACT_NUMBER,
        SERVICE_INPUT_ID.START_DATE,
        SERVICE_INPUT_ID.END_DATE,
        SERVICE_INPUT_ID.CAB_NUMBER
    ];

    public static GET_SERVICE_INPUTS_LIST: { [key: number]: number[] } = {
        1: ServiceInputs.SERVICE_1,
        2: ServiceInputs.SERVICE_2,
        3: ServiceInputs.SERVICE_1_3_4,
        4: ServiceInputs.SERVICE_1_3_4,
        5: ServiceInputs.SERVICE_5,
        6: ServiceInputs.SERVICE_6_9,
        7: ServiceInputs.SERVICE_7_8_11,
        8: ServiceInputs.SERVICE_7_8_11,
        9: ServiceInputs.SERVICE_6_9,
        10: ServiceInputs.SERVICE_10,
        11: ServiceInputs.SERVICE_7_8_11,
        12: ServiceInputs.SERVICE_12_19,
        13: ServiceInputs.SERVICE_13,
        14: ServiceInputs.SERVICE_14,
        15: ServiceInputs.SERVICE_15,
        16: ServiceInputs.SERVICE_16,
        17: ServiceInputs.SERVICE_17,
        18: ServiceInputs.SERVICE_18,
        19: ServiceInputs.SERVICE_12_19,
        20: ServiceInputs.SERVICE_20,
        41: ServiceInputs.SERVICE_21,
        58: ServiceInputs.SERVICE_21,
        59: ServiceInputs.NEW_PRODUCTION_SERVICE,
        60: ServiceInputs.NEW_PRODUCTION_SERVICE,
        61: ServiceInputs.NEW_PRODUCTION_SERVICE,
        62: ServiceInputs.NEW_PRODUCTION_SERVICE,
        110: ServiceInputs.SERVICE_110,

        //NOTE: key represents the service id
    };
}
